import axios from 'axios'
import auth from './auth'
import { Notify } from "vuetify-message-snackbar";
// axios 配置
axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = process.env.VUE_APP_REQUEST_BASE_URL
console.log('axios.defaults.baseURL=>' + axios.defaults.baseURL)

//POST传参序列化
axios.interceptors.request.use(
    config => {
        // console.log(config);
        let header = {
            // 自定义 headers
            token: '', // 授权凭证
        }
        if (auth.loggedIn()) {
            header['token'] = auth.getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }

        Object.assign(config.headers.common, header)
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

//返回状态判断
axios.interceptors.response.use(
    response => {
        if (response.data && response.data.status) {
            if (response.data.status !== 0) {
                console.log('response', response.data.message) // for debug
                Notify.error(response.data.message);
                // return Promise.reject(response.data.message);
            }
            if (response.data.status === 100) {
                auth.logout()
            }
        }
        return response
    },
    error => {
        console.log('err', error) // for debug
        if (error) {
            // 401 说明 token 验证失败
            // 可以直接跳转到登录页面，重新登录获取 token
            // this.$router.push({name: 'Login'});
            // auth.logout()
            // location.href = '/login';
            Notify.error("服务器开小差了，您稍后再试！");
        }

        if (error.response) {
            //全局ajax错误信息提示
            Notify.error(error.response.data);
        }
        return Promise.reject(error)
    }
)

export function tansParams(params) {
    let result = ''
    Object.keys(params).forEach((key) => {
        if (!Object.is(params[key], undefined) && !Object.is(params[key], null) && !Object.is(JSON.stringify(params[key]), '{}')) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
        }
    })
    return result
}
// 通用下载方法
export function download(url, params) {
    return axios.get(url, params, {
        // // transformRequest: [(params) => {
        // //     return tansParams(params)
        // // }],
        // headers: {
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        //     // 'response-content-type': 'application/octet-stream',
        //     // 'content-disposition': 'attachment; filename="' + '111' + '.mp4"'
        // },
        responseType: 'blob'
    }).then((res) => {
        // console.log(res)
        // const filename = res.headers["content-disposition"];
        // const blob = new Blob([res.data],{type: 'video/mp4'});
        let downloadElement = document.createElement("a");
        downloadElement.style.display = 'none'
        // let href = window.URL.createObjectURL(blob);
        let href = window.URL.createObjectURL(res.data);
        downloadElement.href = href;
        downloadElement.download = decodeURIComponent('111.mp4');
        // downloadElement.download = decodeURIComponent(filename.split("filename=")[1]);
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);

        window.URL.revokeObjectURL(href);

        // const content = data
        // const blob = new Blob([content])
        // if ('download' in document.createElement('a')) {
        //     const elink = document.createElement('a')
        //     elink.download = filename
        //     elink.style.display = 'none'
        //     elink.href = URL.createObjectURL(blob)
        //     document.body.appendChild(elink)
        //     elink.click()
        //     URL.revokeObjectURL(elink.href)
        //     document.body.removeChild(elink)
        // } else {
        //     navigator.msSaveBlob(blob, filename)
        // }
    }).catch((r) => {
        console.error(r)
    })
}
export function fetch(url, config = { method: 'get' }) {
    console.log('fetch')
    return axios.request({ ...config, url })
    // return new Promise((resolve, reject) => {
    //   axios.request({ ...config, url })
    //     .then(response => {
    //       resolve(response.data);
    //     }, err => {
    //       reject(err);
    //     })
    //     .catch((error) => {
    //       reject(error)
    //     })
    // })
}

export default axios
